import { useState } from 'react';
import { useTaskStore } from '../stores/taskStore';

function ListItemNew() {
    const [ newItem, setNewItem ] = useState('');

    const addTask = useTaskStore(state => state.addTask)
    
    const handleAddItem = () => {
        addTask(newItem);
        setNewItem('');
    }

    return (   
        <div key='new' className="todo-item-new">
            <label>
                <input type="text" value={newItem} 
                    onChange={ e => { setNewItem(e.target.value); }} 
                    onKeyPress={ (e) => {
                        if(e.key !== 'Enter') return;
                        handleAddItem();
                    } }
                    />
                <button className="button-todo-add" onClick={handleAddItem}>Add</button>
            </label>
        </div>
    );
  }
  
  export default ListItemNew;
  